export const CityMinLength = 3;
export const CityMaxLength = 100;
export const CityDebounceTime = 300;
export const RequestLimit = 100;
export const CityControlName = 'city';
export const CityLabel = 'Населений пункт';
export const CityPlaceholder = '';
export const CityClasses = 'form-col w-30';
export const WarehouseOptionDisabledTooltip =
  'Немає відділень Nova Post. Оберіть інший населений пункт';
export const PostboxOptionDisabledTooltip =
  'Немає поштоматів. Оберіть інший населений пункт';
export const LatinLettersTooltip =
  `Виберіть місто доставки з довідника.
  Для пошуку міста почніть вводити назву латинськими літерами`;
export const AddressCityTooltip = 'Вкажіть назву міста доставки';
export const InternationalCityErrors = {
  objectMask: 'Оберіть населений пункт зі списку',
  pattern: 'Це поле містить недопустимі символи',
  required: 'Це поле обов\'язкове',
  minlength: 'Назва занадто коротка',
};
